export const frenchCountries = () => {
  return ['FR', 'GP', 'MQ', 'GY', 'RE', 'PM', 'YT', 'BL', 'MF', 'WF', 'PF', 'NC'];
}

export const isFrench = (patient) => {
  return frenchCountries().includes(patient.country)
}